const API_PORT = 5001;

export const isLocal = () => window.location.host.includes("localhost");

const isDeployedQa = () =>
  window.location.host.includes("qa-globalentrysentry") ||
  window.location.host.includes("qa.appointmentscanner");

const shouldUseLocalProd = () => localStorage.getItem("LOCAL_PROD");

export const isQA = () =>
  isDeployedQa() || (isLocal() && !shouldUseLocalProd());

export const getApiDomain = () => {
  if (isLocal()) {
    if (shouldUseLocalProd()) {
      console.log("local PROD endpoint call");
      return `http://localhost:${API_PORT}/globalentrysentry/us-central1/public`;
    } else {
      console.log("local QA endpoint call");
      return `http://localhost:${API_PORT}/qa-globalentrysentry/us-central1/public`;
    }
  } else {
    if (isDeployedQa()) {
      console.log("deployed QA endpoint call");
      return "https://us-central1-qa-globalentrysentry.cloudfunctions.net/public";
    } else {
      return "https://us-central1-globalentrysentry.cloudfunctions.net/public";
    }
  }
};

export const rootDomain = isLocal()
  ? window.location.origin
  : "https://appointmentscanner.com/locations";
